import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sfx-table__bottom flex flex-center full-width q-mt-lg" }

import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxSelect from "src/components/select/SfxSelect.vue"
import { TABLE_PAGING_VALUES } from "src/util/constants/table"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { TableBottom } from "src/util/types/components/sfxTable"
import { computed, PropType, ref } from "vue"

//region Props and Emits

const pageButtonSize = "10px"

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableBottom',
  props: {
  pageData: {
    type: Object as PropType<TableBottom>,
  },

  currentPage: {
    type: Number,
  },

  rowsPerPage: {
    type: Number,
  },

  pageSizeList: {
    type: Array as PropType<Array<number>>,
    default: () => TABLE_PAGING_VALUES,
  },
},
  emits: ["update:currentPage", "update:rowsPerPage"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const pageNumber = computed({
  get() {
    return props.currentPage
  },

  set(value) {
    emit("update:currentPage", value)
  },
})

const rowsPerPage = computed({
  get() {
    return props.rowsPerPage
  },

  set(value) {
    emit("update:rowsPerPage", value)
  },
})

const rowSelectOpen = ref(false)

const rowSelectClass = computed(() => {
  return { "sfx-table__bottom-select-arrow-open": rowSelectOpen.value }
})

const options = computed(() => props.pageSizeList.filter((v) => v !== rowsPerPage.value).reverse())

//endregion

//region Functions

function rowSelectOpened() {
  rowSelectOpen.value = true
}

function rowSelectClosed() {
  rowSelectOpen.value = false
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SfxBtnOutline, {
      icon: _unref(Icons).CHEVRON_LEFT,
      disable: props.pageData.isFirstPage,
      onClick: props.pageData.prevPage,
      padding: pageButtonSize
    }, null, 8, ["icon", "disable", "onClick"]),
    _createVNode(_component_q_pagination, {
      modelValue: pageNumber.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageNumber).value = $event)),
      class: "q-px-md",
      color: "inactive",
      "active-color": "none",
      "active-text-color": "navy-base",
      "active-design": "flat",
      max: props.pageData.pagesNumber,
      "max-pages": 6,
      "boundary-numbers": ""
    }, null, 8, ["modelValue", "max"]),
    _createVNode(SfxBtnOutline, {
      icon: _unref(Icons).CHEVRON_RIGHT,
      disable: props.pageData.isLastPage,
      onClick: props.pageData.nextPage,
      padding: pageButtonSize
    }, null, 8, ["icon", "disable", "onClick"]),
    _createVNode(SfxSelect, {
      class: "q-ml-md sfx-table__bottom-select-value",
      "popup-content-class": "sfx-table__bottom-select-list",
      modelValue: rowsPerPage.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rowsPerPage).value = $event)),
      options: options.value,
      "hide-dropdown-icon": "",
      dense: "",
      "menu-anchor": "bottom left",
      "menu-self": "bottom left",
      onPopupShow: rowSelectOpened,
      onPopupHide: rowSelectClosed
    }, {
      after: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass([rowSelectClass.value, "sfx-table__bottom-select-arrow text-subtitle2 text-navy-base"])
        }, [
          _createVNode(_component_q_icon, {
            name: _unref(Icons).CHEVRON_UP,
            size: "25px",
            class: "q-mr-xs"
          }, null, 8, ["name"]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("sfxTable.object_page")), 1)
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue", "options"])
  ]))
}
}

})